import { useSyncExternalStore } from "react";

import {
  appVersionUpdateActions,
  appVersionUpdateStore,
  UnsavedWorkCollection,
} from "./app-version-update.store";
import { coordinatedUpdateCanaryStore } from "./coordinated-update-canary";

type UseAppVersionUpdate = {
  // True while a new version is waiting in canary mode — drives the footer button.
  isUpdateAvailable: boolean;
  // Non-null while the confirmation modal should be shown (footer click, or a
  // morning return that found unsaved work).
  pendingConfirm: UnsavedWorkCollection | null;
  // Footer button: collect unsaved work then open the confirmation modal.
  requestUpdate: () => Promise<void>;
  // Confirm from the modal → apply the coordinated update.
  confirmUpdate: () => void;
  // Dismiss the modal without applying.
  dismissUpdate: () => void;
  isCoordinatedUpdateEnabled: boolean;
};

export const useAppVersionUpdate = (): UseAppVersionUpdate => {
  const { isUpdateAvailable, pendingConfirm } = useSyncExternalStore(
    appVersionUpdateStore.subscribe,
    appVersionUpdateStore.getSnapshot
  );

  const isCoordinatedUpdateEnabled = useSyncExternalStore(
    coordinatedUpdateCanaryStore.subscribe,
    coordinatedUpdateCanaryStore.getSnapshot
  );

  return {
    isUpdateAvailable,
    pendingConfirm,
    requestUpdate: appVersionUpdateActions.requestUpdate,
    confirmUpdate: appVersionUpdateActions.confirmUpdate,
    dismissUpdate: appVersionUpdateActions.dismissUpdate,
    isCoordinatedUpdateEnabled,
  };
};
